import { createGlobalStyle } from 'styled-components';
import { BryntumGanttGlobalStyles } from './components/bryntum-gantt';
import { DueDatePickerPopoverStyles } from './components/due-date-picker-popover';
import { PopconfirmStyles } from './components/popconfirm';
export const GlobalStyle = createGlobalStyle`
  /* NOTE:: Ant doesn't provide this as a variable overrides and the same class is not
  within the tooltip container and attaches itself to body by default. */
  .ant-tooltip-inner {
    /* padding: var(--spacing-03) var(--spacing-05); */
    font-size: 12px;
  }
  .ant-tooltip-arrow {
    display: none;
  }

  .fit-content-tooltip .ant-tooltip-inner {
    width: fit-content;
  }

  .custom-sheet-popover .ant-popover-inner-content {
    padding: 0;
  }

  .ant-notification-notice-with-icon
  .ant-notification-notice-message {
    margin-left: var(--spacing-08);
  }

  .ant-notification-notice-with-icon
  .ant-notification-notice-description {
    margin-left: var(--spacing-08);
    max-width: 250px
  }
   input[disabled], textarea[disabled] {
    -webkit-text-fill-color: var(--gray-100);
  }

  :root[data-new-theme-enabled='true'] input[disabled], :root[data-new-theme-enabled='true'] textarea[disabled] {
   -webkit-text-fill-color: inherit;
  }

  ${DueDatePickerPopoverStyles};
  ${PopconfirmStyles};
  ${BryntumGanttGlobalStyles};
`;
